'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

// Actions


// Utils


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _navigationActions = require('../../reducers/navigationActions');

var _staticResourceUtil = require('./staticResourceUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Redux connect methods
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatchNavigateToStaticPage: function dispatchNavigateToStaticPage(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToStaticPage)(ownProps.config.resourceName));
        }
    };
};

var StaticPageLink = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(StaticPageLink, _React$Component);

    function StaticPageLink() {
        _classCallCheck(this, StaticPageLink);

        return _possibleConstructorReturn(this, (StaticPageLink.__proto__ || Object.getPrototypeOf(StaticPageLink)).apply(this, arguments));
    }

    _createClass(StaticPageLink, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                config = _props.config,
                dispatchNavigateToStaticPage = _props.dispatchNavigateToStaticPage;

            var href = (0, _staticResourceUtil.getStaticPageUrl)(config.resourceName);

            return _react2.default.createElement(
                'a',
                { href: href, onClick: dispatchNavigateToStaticPage },
                config.displayName
            );
        }
    }]);

    return StaticPageLink;
}(_react2.default.Component)) || _class);


StaticPageLink.propTypes = {
    config: _propTypes2.default.object.isRequired,
    dispatchNavigateToStaticPage: _propTypes2.default.func
};

exports.default = StaticPageLink;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/static/StaticPageLink.js
// module id = 716
// module chunks = 0